import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Shipping: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Shipping Information | Born in YU</title>
        <meta name="description" content="Learn about Born in YU shipping policies, delivery times, and international shipping options for Yugoslav nostalgia apparel." />
        <link rel="canonical" href="https://borninyu.com/shipping" />
      </Helmet>
      <main className="min-h-screen bg-white">
      <section className="p-6 md:p-24">
        <div className="max-w-4xl mx-auto">
          <div className="border-[3px] border-black p-8 md:p-16 relative">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white px-4 border-[3px] border-black font-black uppercase tracking-widest text-sm">
              {t('shipping.classification')}
            </div>

            <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-8">
              {t('footer.links.shipping')}
            </h1>

            <div className="font-typewriter text-sm leading-relaxed uppercase text-gray-800 space-y-6">
              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('shipping.processingTime')}</h3>
                <p>{t('shipping.processingText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('shipping.shippingMethods')}</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>{t('shipping.standardShipping')}</li>
                  <li>{t('shipping.expressShipping')}</li>
                  <li>{t('shipping.internationalShipping')}</li>
                </ul>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('shipping.shippingCosts')}</h3>
                <p>{t('shipping.shippingCostsText')}</p>
              </div>

              <div className="border-l-4 border-[#C41E3A] pl-6 py-4 bg-red-50">
                <h3 className="font-black text-lg mb-2 text-[#C41E3A]">
                  {t('shipping.trackingInfo')}
                </h3>
                <p>{t('shipping.trackingInfoText')}</p>
              </div>

              <div className="border-2 border-black p-6 bg-gray-50 mt-8">
                <h3 className="font-black text-lg mb-4">{t('shipping.internationalCustoms')}</h3>
                <p className="text-xs">{t('shipping.internationalCustomsText')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default Shipping;
